export default __webpack_public_path__ + "media/images/react_icons/property/gym-c2d5ea2e8f5a35fe1fa2b71126659d4b.svg";